export default __webpack_public_path__ + "static/media/image-3.3acb4f0f.svg";